export const CONST_RESIDENT = '1';
export const CONST_NOT_RESIDENT = '2';
